import type { OwnerClaimKind, OwnerClaimStatus } from './site-billing';
import { ownerAdvanceAmount, ownerMilestoneValue } from './quote-calc';

/**
 * Mốc thu tiền chủ đầu tư theo giai đoạn (anh Tiến 28/10/2026, lộ trình Dự án thi công PR 4; DEC-577, docs/phases/P21/moc-thu-tien.md).
 * Mỗi mốc: tên (Ký HĐ, Nghiệm thu sản xuất, Bàn giao…), loại đợt (tạm ứng / nghiệm thu / thu giữ bảo hành), % HĐ, giai đoạn gắn (DEC-573).
 *  - Chờ: giai đoạn gắn chưa Xong. Đến hạn: giai đoạn Xong (hoặc mốc không gắn giai đoạn) mà chưa lập đợt → nhắc kế toán.
 *  - Lập đợt từ mốc: số tiền gợi ý = HĐ có VAT × % (tạm ứng), HĐ chưa VAT × % (nghiệm thu), tiền đang giữ (bảo hành). Đợt hủy → mốc về Đến hạn.
 */
export const OWNER_MILESTONE_STATUSES = ['waiting', 'due', 'claimed', 'paid'] as const;
export type OwnerMilestoneStatus = (typeof OWNER_MILESTONE_STATUSES)[number];
export const OWNER_MILESTONE_STATUS_LABELS: Record<OwnerMilestoneStatus, string> = {
  waiting: 'Chờ giai đoạn xong',
  due: 'Đến hạn lập đợt',
  claimed: 'Đã đề nghị',
  paid: 'Đã thu đủ',
};
export const OWNER_MILESTONE_MAX = 30;

/** phaseDone: null = mốc không gắn giai đoạn (đến hạn ngay) */
export function ownerMilestoneStatus(m: { phaseDone: boolean | null; claimStatus: OwnerClaimStatus | null }): OwnerMilestoneStatus {
  if (m.claimStatus === 'paid') return 'paid';
  if (m.claimStatus === 'draft' || m.claimStatus === 'sent') return 'claimed';
  return m.phaseDone === false ? 'waiting' : 'due';
}

/** Số gợi ý khi lập đợt từ mốc: tạm ứng = số tiền đề nghị; nghiệm thu = giá trị nghiệm thu chưa VAT; bảo hành = null (lấy tiền đang giữ) */
export function ownerMilestoneSuggest(kind: OwnerClaimKind, c: { contractValue: number; vatRate: number }, pct: number): number | null {
  if (kind === 'advance') return ownerAdvanceAmount(c.contractValue, c.vatRate, pct);
  if (kind === 'progress') return ownerMilestoneValue(c.contractValue, pct);
  return null;
}

/** Kiểm danh sách mốc: tổng % theo từng loại ≤ 100. Trả lỗi đầu tiên hoặc null. */
export function ownerMilestonesError(list: { kind: OwnerClaimKind; pct: number }[]): string | null {
  for (const k of ['advance', 'progress'] as const) {
    const t = list.filter((m) => m.kind === k).reduce((a, m) => a + m.pct, 0);
    if (t > 100.0001) return `Tổng % các mốc ${k === 'advance' ? 'tạm ứng' : 'nghiệm thu'} là ${Math.round(t * 100) / 100}%, vượt 100% HĐ`;
  }
  return null;
}
